export default function NotFoundPage() {
  return <div>not found</div>;
}
